import React, { useState } from "react";
import styled from "styled-components";

// Styled Components
const Container = styled.div`
  width: 80vw;
  margin-left: 20vw;
  overflow-y: auto;
  @media (max-width: 768px) {
    width: 80%;
    margin-left: 20vw;
  }
`;

const Header = styled.header`
  background: url(/header.jpg) center center/cover no-repeat;
  color: #fff;
  text-align: center;
  padding: 2em 0;
  height: 30vh;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
    @media (max-width: 768px) {
      height: 15vh;
    }
`;

const Section = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2em;
  margin: 5em 0;
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin: 2em 0;
    @media (max-width: 768px) {
    width: 60%
    justify-content: center;
    margin: 0 15%
    gap: 5px;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    font-size: 0.8rem;
  }
`;

const ProjectCard = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1em;
  background: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
`;

const Footer = styled.footer`
  text-align: center;
  margin: 2em 0;
  color: #333;
`;

const ImageWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextWrapper = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 500px;
`;

const ProfileImage = styled.img`
  width: 15vw;
  height: auto;
  border-radius: 10px;
    @media (max-width: 768px) {
    width: 80%;
  }
`;

// React Component
const Portfolio = () => {
  const [projects] = useState([
    { title: "M-Archive", description: "닌텐도의 마리오 홍보 페이지 | HTML, CSS", link: "https://id2el.github.io/M-Archive/" },
    { title: "Deli", description: "트위터 클론코딩 SNS | JS, React", link: "https://nwitter-reloaded-ad7cb.web.app/" },
    { title: "Momentum", description: "모멘텀 클론코딩 | JS, React", link: "https://id2el.github.io/Momentum_VP/" },
  ]);

  return (
    <Container>
      {/* Header */}
      <Header>
      </Header>

      {/* About Section */}
      <Section id="about">
        <ImageWrapper>
          <ProfileImage src="/me.jpg" alt="Yoon Yurim" />
        </ImageWrapper>
        <TextWrapper>
          <h3>Yoon Yurim</h3>
          <p>Web Frontend Developer</p>
          <p>다양한 고객의 니즈에 맞춰 개발을 하고, </p><p>기업에게 가치있는 인재로 성장하고자 합니다.</p>
          <p>HTML5, CSS3, JavaScript, jQuery, TypeScript, JSX, React</p>
          <p>yyl3524@naver.com</p>
        </TextWrapper>
      </Section>

      {/* Projects Section */}
      <Section id="projects">
        <h2>Projects</h2>
        <ProjectsGrid>
          {projects.map((project, index) => (
            <ProjectCard key={index}>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <a href={project.link} target="_blank" rel="noopener noreferrer">
                View Project
              </a>
            </ProjectCard>
          ))}
        </ProjectsGrid>
      </Section>

      {/* Footer */}
      <Footer>
        <p>&copy; 2024 Yoon Yurim. All rights reserved.</p>
      </Footer>
    </Container>
  );
};

export default Portfolio;
